import { ESTIMATED_ROW_HEIGHT } from "./constants";

/**
 * Výpočet odhadu výšky záznamu.
 * - Pomáhá VirtualizedListu správně vyrenderovat obsah.
 * - Je nutné započítat i děti, jinak dojde k rozhození velikosti scrollbaru či dokonce při automatickém zobrazení uživatelů komponenta zaskroluje až dolů.
 * - Jedná se jen opravdu o odhad. Sama knihovna si při renderu velikost přepočítá.
 *
 * @param recordsIdsCount Počet standardních záznamů.
 * @param rootNodesChildrenCount Počet dětí záznamů.
 * @returns Konstantu odhadu výšky záznamu nebo pokud dojde k výpočtu většímu než konstanty, tak navrátí výpočet.
 */
export const calculateEstimateOfRowHeight = (recordsIdsCount: number, rootNodesChildrenCount: number) => {
    if (recordsIdsCount <= 0) return 0;
    return Math.max(ESTIMATED_ROW_HEIGHT, (rootNodesChildrenCount / recordsIdsCount) * ESTIMATED_ROW_HEIGHT);
};
